import { render } from "./dripicons.vue?vue&type=template&id=052fc44e"
import script from "./dripicons.vue?vue&type=script&lang=js"
export * from "./dripicons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gapp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__